import { get, put, post } from ".";

const fetchNotifications = (page: number = 1, pageSize: number = 20) => {
    return get({
        subUrl: `Notification?page=${page}&pageSize=${pageSize}`,
        isAuth: false,
    });
};

const getUnreadCount = () => {
    return get({
        isAuth: false,
        subUrl: "Notification/unread-count",
    });
};

const markAsRead = (id: number) => {
    return put({
        subUrl: `Notification/${id}/read`,
        data: {},
        isAuth: false,
    });
};

const markAllAsRead = () => {
    return put({
        subUrl: "Notification/read-all",
        data: {},
        isAuth: false,
    });
};

const markCaseNotificationsAsRead = (caseId: number) => {
    return put({
        subUrl: `Notification/read-by-case/${caseId}`,
        data: {},
        isAuth: false,
    });
};

const sendNotification = (payload: any) => {
    return post({
        subUrl: "Notification/send",
        data: payload,
        isAuth: false,
    });
};

const notificationApi = {
    fetchNotifications,
    getUnreadCount,
    markAsRead,
    markAllAsRead,
    markCaseNotificationsAsRead,
    sendNotification
};

export default notificationApi;
